// PW TOOLS JS FRONT
window.showMessage = showMessage
window.popup = popup
window.toggleSidebar = toggleSidebar
window.closeSidebar = closeSidebar
window.closeAllSidebar = closeAllSidebar
window.scrollToGo = scrollToGo
window.copy = copy
window.checkPasswordStrength = checkPasswordStrength
window.inputFile = inputFile
window.formatDecimal = formatDecimal
window.jsInput = jsInput
window.txtDefilant = txtDefilant
window.resetInfoTrafic = resetInfoTrafic

// Fonction input file
function inputFile(selector = '.input-file') {
    $(selector).each(function() {
        let fileInput = $(this).find('input[type="file"]');

        fileInput.on('change', function(event) {
            let this_return = $(this).next().next();
            this_return.html($(this).val().replace('C:\\fakepath\\', ' '));
        });
    });
}

// Fonction qui affiche une notification en bas du header pendant 3 secondes
// type : ( string ) class qu'aura l'élément ajouté ( success, error ou delete )
// message : ( string ) message affiché
function showMessage(type, message) {
    var alert = $('<p>')
    alert.addClass('msg-info flash')
    alert.addClass(type)
    alert.html(message)

    $('body').append(alert)

    setTimeout(function () {
        alert.addClass('open')
    }, 100)

    setTimeout(function () {
        alert.removeClass('open')
    }, 3000)

    setTimeout(function () {
        alert.remove()
    }, 3500)
}

// POPUP
function popup(pop) {
    $('body').addClass('mode-popup')
    pop.addClass('open')

    $(document).on('mouseup',function(e){
        if (!pop.is(e.target) && pop.has(e.target).length === 0)
        {
            pop.removeClass('open')
            $('body').removeClass('mode-popup')
        }
    });
}

function txtDefilant() {
    $('.txt-defilant').each(function() {
        var texte = $(this).html();
        $(this).html('<div><span>' + texte + '</span><span>' + texte + '</span></div>');
    });
}

// TOGGLE SIDEBAR
function toggleSidebar(element) {
    let sidebar = $('#' + element)
    let btn = $('[data-toggle-sidebar="'+element+'"]')

    sidebar.toggleClass('is-open');
    btn.toggleClass('actif');

    if($('.sidebar-toggle:not(#'+element+')').hasClass("is-open")) {
        $('.sidebar-toggle:not(#'+element+') [data-toggle-sidebar]').attr('aria-expanded','false');
        $('[data-toggle-sidebar]:not([data-toggle-sidebar="'+element+'"])').removeClass('actif');
        $('.sidebar-toggle:not(#'+element+')').removeClass("is-open");
    }

    if(sidebar.hasClass('is-open')) {
        $('body').addClass('mode-popup')
        btn.attr('aria-expanded','true')
    } else {
        btn.attr('aria-expanded','false');
        $('body').removeClass('mode-popup')
    }

    $(document).mouseup(function (e) {
        if (!sidebar.is(e.target) && sidebar.has(e.target).length === 0) {
            closeSidebar(element)
        }
    });
}

function closeSidebar(element) {
    let sidebar = $('#' + element)
    let btn = $('[data-toggle-sidebar="'+element+'"]')

    sidebar.removeClass('is-open')
    btn.attr('aria-expanded','false');
    btn.removeClass('actif');
    $('body').removeClass('mode-popup')
}

function closeMenu() {
    let nav = $('#main-menu');

    $(this).attr('aria-expanded','false');
    $('.js-toggle-nav').removeClass('menu-open');
    nav.removeClass('showing-nav')
}

function closeAllSidebar() {
    if($('.sidebar-toggle').hasClass("is-open")) {
        $('[data-toggle-sidebar]').attr('aria-expanded','false');
        $('[data-toggle-sidebar]').removeClass('actif');
        $('.sidebar-toggle').removeClass("is-open");
        $('body').removeClass('mode-popup')
    }
}

// COPY FUNCTION
function copyLegacy(text) {
    let textArea = document.createElement("textarea")
    textArea.value = text
    document.body.appendChild(textArea)
    textArea.focus({preventScroll: true})
    textArea.select()

    try {
        document.execCommand('copy')
        showMessage('success','texte copié !');

    } catch (err) {
        console.error('Copy error', err)
        showMessage('error','texte non copié !');
    }

    document.body.removeChild(textArea)
}

function copy(selector) {
    let textToCopy = selector.text()

    if (location.protocol === 'https:') {
        // marche uniquement en https
        navigator.clipboard.writeText(textToCopy).then(function() {
            showMessage('success','texte copié !');
        }, function() {
            showMessage('error','texte non copié !');
        });

    } else {
        copyLegacy(textToCopy)
    }
}

// SCROLL TO GO
function scrollToGo(selector) {
    if (selector.length) {
        if ($('sidebar-toggle').hasClass("is-open")) {
            $('.sidebar-toggle').removeClass("is-open");
        }

        $("html, body").animate({ scrollTop: $(selector).offset().top - ($('header').height()-1) }, 1000);
    }
    return false
}

function checkPasswordStrength(e) {
    let pwdMsg = $('.pwd-msg')
    let number = /([0-9])/;
    let alphabets = /([a-zA-Z])/;
    let special_characters = /([~,!,@,#,$,%,^,&,*,-,_,+,=,?,>,<])/;
    let password = e.val().trim();

    if(password.length === 0) {
        pwdMsg.removeClass('error success warning');
        pwdMsg.html("14 caractères minimum, lettres, chiffres et caractères spéciaux");

    } else {
        if (password.length < 14) {
            pwdMsg.removeClass('error success warning');
            pwdMsg.addClass('error');
            pwdMsg.html("Votre mot de passe doit faire au moins 14 caractères");
        } else {
            if (password.match(number) && password.match(alphabets) && password.match(special_characters)) {
                pwdMsg.removeClass('error success warning');
                pwdMsg.addClass('success');
                pwdMsg.html("Votre mot de passe est acceptable");
            }
            else {
                pwdMsg.removeClass('error success warning');
                pwdMsg.addClass('warning');
                pwdMsg.html("Votre mot de passe doit inclure des lettres, des nombres et des caractères spéciaux");
            }
        }
    }
}

function formatDecimal(number, sep = ',') {
    if (number === null || number === undefined || number === '') {
        return '0';
    }

    // Convertir en nombre si c'est une chaîne
    number = parseFloat(number);

    // Masque les décimales si égales à .00
    const all = Math.floor(number);
    const fraction = number - all;

    if (Math.abs(fraction) < 0.000001) { // Comparaison flottante plus sûre
        return number.toLocaleString('fr-FR', {maximumFractionDigits: 0}).replace(/\s/g, ' ');
    }

    return number.toLocaleString('fr-FR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).replace(/\s/g, ' ').replace(',', sep);
}

function jsInput() {
    // Sélectionne tous les wrappers avec la classe js-input
    const wrappers = $('.js-input');

    function handleActiveState(wrapper) {
        // Trouve l'input/select dans la structure imbriquée
        const input = wrapper.find('input, select').first();

        // Si aucun input/select trouvé, on quitte
        if (!input.length) return;

        // Gestion spéciale pour les selects (valeur vide != placeholder)
        const isSelect = input.is('select');
        const hasValue = isSelect
            ? input.val() !== '' && input.val() !== null
            : (input.val() || '').trim() !== '';

        // Gestion des classes
        wrapper.toggleClass('active', input.is(':focus'));
        wrapper.toggleClass('filled', hasValue);
    }

    wrappers.each(function() {
        const wrapper = $(this);
        const input = wrapper.find('input, select').first();

        if (!input.length) return;

        // Événements pour gérer les changements d'état
        input.on('focus blur input change', () => handleActiveState(wrapper));

        // Clic sur le wrapper pour focus l'input
        wrapper.on('click', function(e) {
            // Empêche le déclenchement si on clique sur un élément interactif
            if ($(e.target).closest('label, i, .habillage, .input-picto').length) {
                input.focus();
            }
        });

        // Initialisation
        handleActiveState(wrapper);
    });
}

function resetInfoTrafic() {
    $('.js-toggle-trafic-reset').addClass('hide');
    $('.js-toggle-trafic').removeClass('disabled');
    $('.js-toggle-item-trafic').removeClass('hide');
    $('.js-toggle-trafic').removeClass('actif');
    $('.js-toggle-item-trafic').removeClass('open');
}

$(document).ready(function () {
    // INPUT FILE
    inputFile()
    jsInput()

    // RETOUR EN HAUT - créer balise #gotop
    $('#gotop').on('click', function () {
        //
        $('html, body').animate({ scrollTop: 0 }, 'slow')
        return false
    })

    // BOUTON TOGGLE MAIN NAV
    $('.js-toggle-nav').on('click', function () {
        let nav = $('#main-menu');

        $(this).toggleClass('menu-open')
        $(this).removeAttr('aria-expanded')

        if($(this).hasClass('menu-open')) {
            $(this).attr('aria-expanded','true')
            nav.addClass('showing-nav')

        } else {
            $(this).attr('aria-expanded','false');
            nav.removeClass('showing-nav')
        }

        // CLOSE SIDEBAR TOGGLE
        closeAllSidebar()

        return false
    })

    $('.js-close-nav').on('click', function () {
        closeMenu()
    })

    // SCROLL TO
    $('a[href^="#"]').on('click', function() {
        let selector = $(this).attr('href')
        scrollToGo(selector)
    })

    if (window.location.hash) { // Si un hash est présent dans l'URL
        scrollToGo(window.location.hash); // Applique le scroll
    }

    // TOGGLE SIDEBAR
    $('body').on('click', '[data-toggle-sidebar]', function () {
        toggleSidebar($(this).attr('data-toggle-sidebar'))
    });

    // CLOSE SIDEBAR
    $('body').on('click', '[data-close-sidebar]', function () {
        closeSidebar($(this).attr('data-close-sidebar'))
    })

    // subnav
    $('.js-display-subnav').on('click', function() {
        let subnav = $(this).next('.subnav')
        let nav = $('.nav-content')
        let clicker = $('.js-display-subnav')

        if(subnav.hasClass('open')) {
            subnav.removeClass('open')
            $(this).removeClass('actif')
        } else {
            $('.nav-content .subnav').removeClass('open')
            clicker.removeClass('actif')
            subnav.addClass('open')
            $(this).addClass('actif')
        }

        $(document).mouseup(function (e) {
            if (!nav.is(e.target) && nav.has(e.target).length === 0) {
                $('.nav-content .subnav').removeClass('open')
                clicker.removeClass('actif')
            }
        });
    })

    // CLOSE SIDEBAR
    $('.js-close-subnav').on('click', function () {
        $(this).siblings('.js-display-subnav.actif').removeClass('actif')
        $(this).siblings('.subnav.open').removeClass('open')
    })

    // COPY JS
    $('[data-copy]').on('click', function() {
        let copyTarget = $('#' + $(this).attr('data-copy'))
        copy(copyTarget)
    });

    // POPUP
    $('[data-popup]').on('click', function () {
        let pop = $('#' + $(this).attr('data-popup'))
        popup(pop)
    });

    $('.close-popup').on('click', function () {
        $('body').removeClass('mode-popup')
        $(this).parent('.popup').removeClass('open')
    })

    // ONGLETS
    $('[data-onglet]').on('click', function () {
        $(this).siblings('[data-onglet]').removeClass('actif')
        $('#' + $(this).attr('data-onglet')).siblings('.onglet-content').removeClass('open')
        $(this).addClass('actif')
        $('#' + $(this).attr('data-onglet')).addClass('open')
    })

    // TOGGLE SECTION
    $('.toggle-item').on('click', '> .toggle-launcher', function () {
        if ($(this).parent().hasClass('open')) {
            $(this).parent().removeClass('open')
        } else {
            $('.toggle-section .toggle-item.open').removeClass('open')
            $(this).parent().addClass('open')
        }

        return false
    })

    // RECUP EMAIL NEWSLETTER POPUP
    $('[data-popup-news="inscrinews"]').on('click', function () {
        if ($('#recup-email-news:success').length != 0) {
            var email = $('#recup-email-news').val()
            $('#email-newsletter').attr('value', email)
            $('body').addClass('mode-popup')
            $('#' + $(this).attr('data-popup-news')).addClass('open')
        }
    })

    $('.link-to-go').click(function (event) {
        event.preventDefault()
        let url = $(this).attr('data-href')
        window.open(url)
    })

    // INFO TRAFFIC TOGGLE
    $('body').on('click','.js-toggle-trafic' , function(){
        $('.js-toggle-trafic-reset').removeClass('hide');

        if( $(this).hasClass('actif') ) {
            $(this).removeClass('actif');

            if( $('.js-toggle-trafic.actif')[0] ) {
                $(this).addClass('disabled');

                $('.'+$(this).attr('data-toggle-trafic')).removeClass('open');
                $('.'+$(this).attr('data-toggle-trafic')).addClass('hide');

            } else {
                $('.js-toggle-trafic-reset').addClass('hide');
                $('.js-toggle-trafic').removeClass('disabled');
                $('.js-toggle-item-trafic').removeClass('hide');
                $('.js-toggle-trafic').removeClass('actif');
                $('.js-toggle-item-trafic').removeClass('open');
            }

        } else if( $(this).hasClass('disabled') ) {
            $(this).removeClass('disabled');
            $(this).addClass('actif');
            $('.'+$(this).attr('data-toggle-trafic')).removeClass('hide');
            $('.'+$(this).attr('data-toggle-trafic')).addClass('open');

        } else {
            $(this).removeClass('disabled');
            $(this).addClass('actif');
            $(this).siblings('.js-toggle-trafic:not(.actif)').addClass('disabled');
            $('.'+$(this).attr('data-toggle-trafic')).removeClass('hide');
            $('.'+$(this).attr('data-toggle-trafic')).addClass('open');
            $('.'+$(this).attr('data-toggle-trafic')).siblings('.js-toggle-item-trafic:not(.open)').addClass('hide');
        }
    })

    // RESET TOGGLE TRAFIC
    $('body').on('click', '.js-toggle-trafic-reset' , function(){
        resetInfoTrafic()
    })

    // FILTER INFOTRAFIC EXTERNAL
    $('body').on('click', '[data-filter-infotrafic]', function() {
        const filter = $(this).attr('data-filter-infotrafic')
        resetInfoTrafic()
        $('.js-toggle-trafic.'+filter).click();
    })

    // ROCKET FIXED
    const rocket = $('.rocket');
    const headPage = $('.head-page');
    const mainHeaderHeight = $('.main-header').outerHeight();

    const checkRocketPosition = () => {
        const scrollPosition = $(window).scrollTop();
        const headPageBottom = headPage.offset().top + headPage.outerHeight();
        rocket.toggleClass('fixed-rocket', scrollPosition >= headPageBottom - mainHeaderHeight);
    };

    checkRocketPosition();

    $(window).scroll(checkRocketPosition);

    $('body').on('click', '.js-pass-display', function() {
        const input = $(this).siblings('input');
        const isPassword = input.attr('type') === 'password';

        // Basculer le type d'input
        input.attr('type', isPassword ? 'text' : 'password');

        // Basculer les classes d'icône
        $(this).toggleClass('icon-eye-slash icon-eye');
    });

}) // FIN DOCUMENT READY
